import React from 'react';

const PageTabBody = ({ children }) => {
  return <>{children}</>;
};

export default PageTabBody;
